"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var benefitsConfig = {
  oListItem: 'WithNumbers',
  listItem: 'WithCheckmark'
};
/* eslint-disable camelcase */

var BenefitsList = function BenefitsListComponent(_ref) {
  var dataClient = _ref.dataClient,
      pageData = _ref.pageData;
  var benefits_list = pageData.benefits_list;
  return benefits_list.map(function (benefitList) {
    var benefit_title = benefitList.benefit_title,
        benefit_background_color = benefitList.benefit_background_color,
        benefit_body = benefitList.benefit_body;
    var backgroundColor = benefit_background_color;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "benefit-wrapper",
      style: {
        backgroundColor: backgroundColor
      },
      key: dataClient.renderText(benefit_title)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "se-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "benefit"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "benefit-title-col"
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: "benefit-body__heading-2"
    }, dataClient.textToMarkdown(benefit_title))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "benefit-body-col"
    }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
      content: benefit_body,
      baseClass: "benefit-body",
      options: benefitsConfig
    })))));
  });
};

BenefitsList.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  pageData: _propTypes["default"].shape({}).isRequired
};
var _default = BenefitsList;
exports["default"] = _default;